<template>
  <div class="report-group" :class="{ 'is-open': isOpen && !isMobileScreen }">
    <button type="button" class="group-head" @click="toggle">
      <i class="group-arrow"/>
      <span class="group-title">{{ title }}</span>
      <el-tooltip v-if="hint" :content="hint" placement="top">
        <i class="el-icon-info group-hint"/>
      </el-tooltip>
      <span v-if="badge" class="group-badge">{{ badge }}</span>
      <span class="group-spacer"/>
      <span v-if="countLabel" class="group-count">{{ countLabel }}</span>
      <span class="group-amount" :class="amountClass">{{ amount | formatCent }}</span>
    </button>

    <div v-if="isOpen && !isMobileScreen" class="group-body">
      <slot/>
    </div>

    <!-- 手机端：明细放进底部抽屉，表格有完整宽度，也不会把页面撑出横向滚动 -->
    <el-drawer
      v-if="isMobileScreen && drawerVisible"
      :visible.sync="drawerVisible"
      direction="btt"
      size="82%"
      append-to-body
      :with-header="true"
    >
      <div slot="title" class="drawer-title">
        <span>{{ title }}</span>
        <b :class="amountClass">{{ amount | formatCent }}</b>
      </div>
      <div class="drawer-body">
        <slot/>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import mobileMixin from './mobile.js';

export default {
  name: 'DailyReportGroup',
  mixins: [mobileMixin],
  props: {
    title: { type: String, required: true },
    // 笔数，null 表示该分类没有笔数概念（如其他收入）
    count: { type: [Number, String], default: null },
    // 单位：分
    amount: { type: Number, default: 0 },
    // income 红 / pay 绿 / 空为常规色
    tone: { type: String, default: '' },
    // 分类旁的补充说明，走 info 图标 + tooltip，不常驻显示
    hint: { type: String, default: '' },
    // 短标签，如「需转总部」
    badge: { type: String, default: '' },
    defaultOpen: { type: Boolean, default: false },
  },
  data: () => ({
    isOpen: false,
    drawerVisible: false,
  }),
  computed: {
    amountClass() {
      // 0 就是没有：弱化；有金额一律墨色，不再用红绿区分收支（红绿只留给异常）
      return Number(this.amount) === 0 ? 'is-zero' : '';
    },
    countLabel() {
      if (this.count === null || this.count === undefined || this.count === '') return '';
      return `${this.count} 笔`;
    },

  },
  watch: {
    defaultOpen(value) {
      this.isOpen = value;
    },
  },
  created() {
    this.isOpen = this.defaultOpen;
  },
  methods: {
    toggle() {
      if (this.isMobileScreen) {
        this.drawerVisible = true;
        return;
      }
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style src="../report-card.css"></style>

<style scoped>
.report-group + .report-group {
  border-top: 1px solid #f2f4f7;
}

.group-head {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0 24px;
  border: 0;
  background: transparent;
  color: #303133;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: background-color .15s ease;
}

.group-head:hover,
.report-group.is-open .group-head {
  background: #f8fafc;
}

.group-head:focus {
  outline: none;
}

.group-head:focus-visible {
  outline: 2px solid #c6e2ff;
  outline-offset: -2px;
}

.group-arrow {
  width: 0;
  height: 0;
  margin-right: 10px;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 5px solid #b4bccc;
  transition: transform .18s ease;
}

.report-group.is-open .group-arrow {
  transform: rotate(90deg);
}

.group-title {
  font-weight: 500;
  letter-spacing: .2px;
}

.group-hint {
  margin-left: 6px;
  color: #c0c4cc;
  cursor: help;
}

.group-badge {
  margin-left: 8px;
  padding: 0 7px;
  border-radius: 4px;
  background: #fdf6ec;
  color: #e6a23c;
  font-size: 12px;
  line-height: 20px;
}

.group-spacer {
  flex: 1;
}

.group-count {
  margin-right: 24px;
  color: #909399;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.group-amount {
  min-width: 120px;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  font-feature-settings: 'tnum';
  text-align: right;
}

.group-amount.is-zero {
  color: #c0c4cc;
  font-weight: 400;
}

.group-body {
  padding: 8px 24px 20px;
  background: #fbfcfd;
  border-top: 1px solid #f2f4f7;
}

.drawer-title {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
  color: #1f2d3d;
}

.drawer-title b {
  font-variant-numeric: tabular-nums;
}

.drawer-body {
  box-sizing: border-box;
  padding: 0 12px 12px;
  overflow-x: auto;
}

@media (max-width: 1199px) {
  .group-head {
    height: 50px;
    padding: 0 16px;
  }

  .group-body {
    padding: 8px 16px 18px;
  }
}

@media (max-width: 768px) {
  .group-head {
    height: 46px;
    padding: 0 14px;
  }

  .group-count {
    margin-right: 12px;
  }

  .group-amount {
    min-width: 88px;
    font-size: 14px;
  }
}
</style>
